module.exports = __webpack_public_path__ + "img/租赁缴费.c67299cc.png";